(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name payments.controller:PaymentsSignCtrl
   *
   * @description
   *
   */
  angular
    .module('payments')
    .controller('PaymentsSignCtrl', PaymentsSignCtrl);

  function PaymentsSignCtrl($state, $log, $q,$timeout,
                            PaymentsService, PaymentSignListService, ConfigEndpointService,
                            $localStorage, ValidationService, HelperService, $sessionStorage,
                            $rootScope, $translate) {
    var vm = this;
    vm.signButtonDisabled = true;


    vm.init = function () {

      disableSMSButton();

      vm.countryCode = $localStorage.code;

      vm.objectForSignature = {};

      switch ($state.current.name) {
        case "payments.sign":
          loadPayment($state.params.paymentId)
            .then(function (){
              vm.objectForSignature = vm.selectedPaymentForSign;
              if(vm.selectedPaymentForSign.linkList.itemList.requestOTP){
                requestSMSCode(vm.selectedPaymentForSign);
              }
            });
          break;
        case "payments.groupSign":
          loadGroupOfPayments($state.params.groupId)
            .then(function (){
              vm.objectForSignature = vm.paymentsGroupList;
              if(vm.paymentsGroupList.linkList.itemList.requestOTP){
                requestSMSCode(vm.paymentsGroupList);
              }
            });
          break;
        default:
        // Unknown state
      }
      vm.smsPasswordInput = '';
      vm.challengeResponse = '';

      // Hide SMS/Challenge response input by default.
      vm.showInput = false;

      // If there is no country code, load it
      if (!vm.countryCode || vm.countryCode === '') {
        if($rootScope.APP_GLOBAL_SETTINGS.defaultData){
          vm.defaultData = $rootScope.APP_GLOBAL_SETTINGS.defaultData;
          vm.countryCode = vm.defaultData.APILocation;
        }
      }

      //else {
      //  // If country code is not HR, send SMS (SRB and MNE)
      //  if (vm.countryCode && vm.countryCode !== 'hr' && vm.countryCode != 'bh') {
      //    requestSMSCode();
      //  }
      //}

      vm.formSubmitted = false;
      vm.paymentType = $state.params.type || 'other';
      vm.regexPatterns = ValidationService.getRegexPatternsForValidation();
    };

    var loadPayment = function (paymentId) {
      var deferred = $q.defer();
      if($state.params.payment){
        vm.isPaymentDueDateValid = true;
        vm.dueDateUpdateAllowed = true;
        vm.selectedPaymentForSign = $state.params.payment;
        deferred.resolve(vm.selectedPaymentForSign);
      }
      if (paymentId) {
        return PaymentsService.getById(paymentId).then(function (payment) {

          if(vm.countryCode == 'hr' && payment.status == 'Signed'){
            $state.go('payments.finalStep', {paymentObject: payment , paymentId: payment.id, type: 'domestic'});
          }
          
          vm.selectedPaymentForSign = payment;
          if(vm.countryCode !== 'sr'){
            var updateObject = _.find(payment.allowedActionList.itemList, function (item) {
              return item.methodName === 'UpdateOldPaymentDateAllowed';
            });

            if (updateObject) {
              vm.dueDateUpdateAllowed = updateObject.isEnabled;
            }

            // Use only date without hours for compare
            var currentTime = new Date();
            currentTime.setHours(0, 0, 0, 0);
            // Check if all payments have valid due date
            vm.isPaymentDueDateValid = new Date(payment.dueDate) >= currentTime;
          }else{
            vm.isPaymentDueDateValid = true;
            vm.dueDateUpdateAllowed = true;
          }

        }).catch(function (error) {
          $log.error(error);
        });
      }
      return deferred.promise;
    };

    var loadGroupOfPayments = function (paymentGroupId) {
      var deferred = $q.defer();
      if (paymentGroupId) {
        return PaymentSignListService.getSignListById(paymentGroupId).then(function (paymentGroup) {

          vm.paymentsGroupList = paymentGroup;

          if(vm.countryCode !== 'sr'){
            var updateObject = _.find(vm.paymentsGroupList.allowedActionList.itemList, function (item) {
              return item.methodName === 'UpdateOldPaymentDatesAllowed';
            });

            if (updateObject) {
              vm.dueDateUpdateAllowed = updateObject.isEnabled;
            }

            // Use only date without hours for compare
            var currentTime = new Date();
            currentTime.setHours(0, 0, 0, 0);
            // Check if all payments have valid due date
            vm.areAllPaymentsDueDateValid = _.every(vm.paymentsGroupList.paymentList, function (payment) {
              return new Date(payment.dueDate) >= currentTime;
            });
          }else{
            vm.areAllPaymentsDueDateValid = true;
            vm.dueDateUpdateAllowed = true;
          }

        }).catch(function (err) {
          $log.error(err);
        });
      }

      return deferred.promise;
    };

    /*  Single payment */
    vm.updateSinglePaymentDate = function () {
      if (vm.selectedPaymentForSign) {
        // Sign newly created list of payments.
        return PaymentsService.updatePaymentDueDate(vm.selectedPaymentForSign.id).then(function (updatedPayment) {
          if (updatedPayment) {
            // Use only date without hours for compare
            var currentTime = new Date();
            currentTime.setHours(0, 0, 0, 0);
            // Check if all payments have valid due date
            vm.isPaymentDueDateValid = new Date(updatedPayment.dueDate) >= currentTime;
            vm.selectedPaymentForSign = updatedPayment;
          }
        }).catch(function (error) {
          $log.error(error);
        });
      }
    };

    vm.signSinglePayment = function () {
      if (vm.selectedPaymentForSign) {
        vm.formSubmitted = true;

        // Sign newly created list of payments.
        var params = {
          id: vm.selectedPaymentForSign.id
        };

        // SMS for Srb/Mne
        if (vm.smsPasswordInput !== '') {
          params.signData = vm.smsPasswordInput;
        }
        // Challenge for CRO
        if (vm.challengeResponse !== '') {
          params.signData = vm.challengeResponse;
        }

        if(vm.countryCode == 'sl' ){
          params.payment = $state.params.payment;
          if(vm.smsPasswordInput){
            params.payment.signData = vm.smsPasswordInput;
          }else
            params.payment.signData = '';
        }


        return PaymentsService.signPayment(params).then(function (signedPayment) {
          console.log(signedPayment);
          // TODO: Uncomment after API fix - signed payment has no data currently
          // $state.go('payments.finalStep', {paymentId: signedPayment.payment.id, paymentObject: signedPayment.payment, type: vm.paymentType });
          $state.go('payments.finalStep', {paymentObject: signedPayment.payment || signedPayment, paymentId: vm.selectedPaymentForSign.id, type: vm.paymentType});
        }).catch(function (error) {
          $log.error(error);

          if(error && error.resultList[0] && error.resultList[0].key === 'CUTOFF'){
            signLastPayment(error.resultList[0].description, params);
          }else if (error && error.resultList[0] && error.resultList[0].key === 'UpdateOldDate'){
            openUpdateSinglePaymentDueDateModal(params);
          }else{
            HelperService.showMessage(error, 'error');
          }

          // To prevent multiple requests
          vm.formSubmitted = false;
        });
      }
    };

    var signLastPayment = function(message, params){
      if(params){
        PaymentsService.openUpdateCurrencyDateModal()
          .result.then(function (result) {
          if (result == "confirm") {
            params.cutoffChecked = true;
            return PaymentsService.signPayment(params).then(function (signedPayment) {
              console.log(signedPayment);
              // TODO: Uncomment after API fix - signed payment has no data currently
              // $state.go('payments.finalStep', {paymentId: signedPayment.payment.id, paymentObject: signedPayment.payment, type: vm.paymentType });
              $state.go('payments.finalStep', {paymentId: vm.selectedPaymentForSign.id, type: vm.paymentType});
            }).catch(function (error) {
              $log.error(error);
              HelperService.showMessage(error, 'error');
            });
          }
        });
      }
    };

    var openUpdateSinglePaymentDueDateModal = function(params){
      if(params){
        PaymentsService.openUpdatePaymentDueDateModal()
          .result.then(function (result) {
          if (result == "confirm") {
            params.cutoffChecked = true;
            params.useCurrentDate = true;
            return PaymentsService.signPayment(params).then(function (signedPayment) {
              console.log(signedPayment);
              // TODO: Uncomment after API fix - signed payment has no data currently
              // $state.go('payments.finalStep', {paymentId: signedPayment.payment.id, paymentObject: signedPayment.payment, type: vm.paymentType });
              $state.go('payments.finalStep', {paymentId: vm.selectedPaymentForSign.id, type: vm.paymentType});
            }).catch(function (error) {
              $log.error(error);
              HelperService.showMessage(error, 'error');
            });
          }
        });
      }
    };

    /* Group payments */
    vm.updateGroupPaymentDates = function () {
      if (vm.paymentsGroupList) {
        // Update due dates of payments
        return PaymentSignListService.updateGroupPaymentDates(vm.paymentsGroupList.id).then(function (updatedPayments) {
          vm.paymentsGroupList = updatedPayments;

          // Use only date without hours for compare
          var currentTime = new Date();
          currentTime.setHours(0, 0, 0, 0);

          // Check if all payments have valid due date
          vm.areAllPaymentsDueDateValid = _.every(vm.paymentsGroupList.paymentList, function (payment) {
            return new Date(payment.dueDate) >= currentTime;
          });
          console.log(updatedPayments);
        }).catch(function (error) {
          $log.error(error);
        });
      }
    };
    vm.cancelGroupPayments = function () {
      $state.go('payments.paymentsOverview', {myParam: 'not-signed'})
    };

    vm.signGroupPayments = function () {
      if (vm.paymentsGroupList) {
        vm.formSubmitted = true;

        var listForSign = {
          id: vm.paymentsGroupList.id,
          cutoffChecked: false,
          useCurrentDate: false
        };

        if (vm.smsPasswordInput !== '') {
          listForSign.signData = vm.smsPasswordInput;
        }
        if (vm.challengeResponse !== '') {
          listForSign.signData = vm.challengeResponse;
        }

        // Sign newly created list of payments.
        return PaymentSignListService.signAllPaymentsOnList(listForSign).then(function (signedPayments) {
          $state.go('payments.finalStep', {paymentId: vm.paymentsGroupList.id, type: 'group'});
          console.log(signedPayments);
        }).catch(function (error) {
          $log.error(error);
          if(error && error.resultList[0] && error.resultList[0].key === 'CUTOFF'){
            signLastGroupOfPayments(error.resultList[0].description, listForSign);
          }else if (error && error.resultList[0] && error.resultList[0].key === 'UpdateOldDate'){
            openUpdateGroupPaymentsDueDateModal(listForSign);
          }else{
            HelperService.showMessage(error, 'error');
          }

          vm.formSubmitted = false;
        });
      }
    };

    var openUpdateGroupPaymentsDueDateModal = function(params){
      if(params){
        PaymentsService.openUpdatePaymentDueDateModal()
          .result.then(function (result) {
          if (result == "confirm") {
            params.cutoffChecked = true;
            params.useCurrentDate = true;
            return PaymentSignListService.signAllPaymentsOnList(params).then(function (signedPayments) {
              $state.go('payments.finalStep', {paymentId: vm.paymentsGroupList.id, type: 'group'});
              console.log(signedPayments);
            }).catch(function (error) {
              HelperService.showMessage(error, 'error');
              $log.error(error);
            });
          }
        });
      }
    };

    var signLastGroupOfPayments = function(message, params){
      if(params){
        PaymentsService.openUpdateCurrencyDateModal()
          .result.then(function (result) {
          if (result == "confirm") {
            params.cutoffChecked = true;
            return PaymentSignListService.signAllPaymentsOnList(params).then(function (signedPayments) {
              $state.go('payments.finalStep', {paymentId: vm.paymentsGroupList.id, type: 'group'});
              console.log(signedPayments);
            }).catch(function (error) {
              HelperService.showMessage(error, 'error');
              $log.error(error);
            });
          }
        });
      }
    };

    var requestSMSCode = function (payment) {
      // SMS is already sent, no need to send it again on controller init. If user wants to request SMS again, there is button for that action.
      if ($sessionStorage.sentSMS && $sessionStorage.sentSMS !== '') return;
        vm.sendSMS(payment);
    };

    vm.toggleInputVisibility = function () {
      vm.showInput = !vm.showInput;
      var smsInput = document.getElementById("smsInput");
      smsInput.focus();
    };

    vm.sendSMS = function (paymentObj) {
      disableSMSButton();
      var payment = paymentObj || vm.objectForSignature;
      return PaymentsService.requestSMSCode(payment.linkList.itemList.requestOTP)
        .then(function (code) {
          $sessionStorage.sentSMS = true;
          if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation != 'sl') {
            var message = $translate.instant('signPayments.SmsSentSuccessfully');
            HelperService.showTranslatedMessage('success', message,'',3000);
          }
        }).catch(function (error) {
          HelperService.showMessage(error, 'error');
          $log.error(error);
        });
    };

    vm.repeatSmsCounter = 0;
    vm.requestSMSCodeForSlo = function () {
      if (vm.resendSMSInProgress || vm.repeatSmsCounter == 3) return;
      vm.resendSMSInProgress = true;
      vm.repeatSmsCounter++;
      PaymentsService.insertPayment($state.params.payment)
        .then(function (response) {
        })
        .catch(function (response, error) {
          if (response && response.hasWarnings) {
            //show action message modal
            PaymentsService.showModalWithActions(response, objectForInsert);
          } else {
            HelperService.showMessage(response, 'error');
          }
        })
        .finally(function () {
          vm.resendSMSInProgress = false;
        });
    }

    // Delete from storage information about sent SMS
    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
      delete $sessionStorage.sentSMS;
    });

    function disableSMSButton() {
      vm.signButtonDisabled = true;
      $timeout(function () {
        vm.signButtonDisabled = false;
      }, 30000);
    }

    vm.init();
  }
}());
